import React from 'react';
import { connect } from 'react-redux';
import { Didomi } from '../../didomi';
import { initialAction } from '../initialActions';
const mapStateToProps = (state) => {
    return Object.assign({}, state);
};
const mapDispatchToProps = (dispatch) => {
    return {
        initialAction: (context, baseUrl, preloadedConfig) => dispatch(initialAction(context, baseUrl, preloadedConfig)),
    };
};
export const DidomiContainer = (props) => {
    return React.createElement(Didomi, Object.assign({}, props));
};
export default connect(mapStateToProps, mapDispatchToProps)(DidomiContainer);
